<form class="date-picker custom-date cus-input" [class.disabled]="readOnly" [formGroup]="dobForm">
    <span #dateDiv (click)="focusDate($event)">
        <div class="cus-input-date" [ngStyle]="{'min-width':outvalues.date?'19px':'19px'}">
            <input  type="text" class="cus-input" id="dateField" [ngStyle]="{'text-align':outvalues.date? '': 'center'}"
                data-type="{{date.date}}" (keyup)="dateInput($event, date.date)" (input)="dateInput($event, date.date)"
                formControlName="dob0">
            <label class="cus-input placeholder" for="dateField" #dateField [innerHTML]="outvalues.date"></label>
        </div>
        <div class="cus-input-date slash">
            <label class="cus-input placeholder"
                [ngStyle]="{color: dobForm.value.dob0.length === date.date.length? '#000':''}">/</label>
        </div>
        <div class="cus-input-date month" [ngStyle]="{'min-width':outvalues.month?'30px':'20px'}">
            <input type="text" class="cus-input" id="dateField1"
                [ngStyle]="{'text-align':outvalues.month? '': 'center'}" data-type="{{date.month}}"
                (keyup)="dateInput($event, date.month)" (input)="dateInput($event, date.month)" formControlName="dob1">
            <label class="cus-input placeholder" for="dateField1" #dateField [innerHTML]="outvalues.month"></label>
        </div>
        <div class="cus-input-date slash">
            <label class="cus-input placeholder"
                [ngStyle]="{color: dobForm.value.dob1.length === date.month.length? '#000':''}">/</label>
        </div>
        <div class="cus-input-date year">
            <input  type="text" class="cus-input" id="dateField2" [ngStyle]="{'text-align':outvalues.year? '': 'center'}"
                data-type="{{date.year}}" (keyup)="dateInput($event, date.year)" (input)="dateInput($event, date.year)"
                formControlName="dob2">
            <label class="cus-input placeholder" for="dateField2" #dateField [innerHTML]="outvalues.year"></label>
        </div>
    </span>
    <div class="cus-input-date">
        <input [disabled]="readOnly" #inputCalender type="date" class="cus-input" id="dateField3" (input)="dateInput($event)">
        <!-- <label class="cus-input placeholder" for="dateField3">date</label> -->
    </div>

</form>